document.addEventListener('DOMContentLoaded', function () {
  const productSection = document.querySelector('.product');
  if (!productSection) return;

  const allDetails = productSection.querySelectorAll('details');

  allDetails.forEach(function (detail) {
    detail.addEventListener('toggle', function () {
      if (this.open) {
        allDetails.forEach(function (other) {
          if (other !== detail && other.open) {
            other.open = false;
          }
        });
      }
    });
  });
});
